@if (loader) {
  <div class="loader"><img src="assets/images/loader.gif" alt="Loading..." width="60" /></div>
}
@if (plotlyWidget) {
  <div>
    @if (!loader) {
      <plotly-plot [data]="$safeNavigationMigration(plotlyWidget?.data)" [layout]="$safeNavigationMigration(plotlyWidget?.layout)" [config]="$safeNavigationMigration(plotlyWidget?.config)" [style]="{position: 'relative', width: '100%', height: '100%'}" [useResizeHandler]="false"></plotly-plot>
    }
  </div>
}